<template>
  <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
  >
    <v-text-field
            slot="activator"
            v-model="computedDateFormatted"
            :label="label"
            readonly
    ></v-text-field>
    <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
  </v-menu>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({

  }),

  computed: {

  },

  methods: {

  }
}
</script>

<style lang="scss">

</style>
